var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAuthFlow } from "@src/features/AuthFlow";
import { StartView, LoginView, SignupView, CaptchaView, ProfileView, ProvisionedView, AgreementView, VerifyEmailView, VerifyResetView, PasskeyView, ResetPasswordView, ConsentView, InvalidAuthView, ErrorView, MismatchEmailView, } from "@pangeacyber/react-mui-authn";
import { FlowPhase } from "./types";
import FlowCompleteView from "@src/components/FlowCompleteView";
import FlowReturnView from "@src/components/FlowReturnView";
import LoadingView from "@src/components/LoadingView";
var AuthFlowView = function (_a) {
    var options = _a.options;
    var _b = useAuthFlow(), phase = _b.phase, data = _b.data, loading = _b.loading, error = _b.error, cbParams = _b.cbParams, update = _b.update, restart = _b.restart, reset = _b.reset;
    var componentProps = {
        options: options,
        data: data,
        error: error,
        cbParams: cbParams,
        loading: loading,
        update: update,
        reset: reset,
        restart: restart,
    };
    switch (phase) {
        case FlowPhase.START:
            return _jsx(StartView, __assign({}, componentProps));
        case FlowPhase.SIGNUP:
            return _jsx(SignupView, __assign({}, componentProps));
        case FlowPhase.LOGIN:
            return _jsx(LoginView, __assign({}, componentProps));
        case FlowPhase.CAPTCHA:
            return _jsx(CaptchaView, __assign({}, componentProps));
        case FlowPhase.PROFILE:
            return _jsx(ProfileView, __assign({}, componentProps));
        case FlowPhase.VERIFY_EMAIL:
            return _jsx(VerifyEmailView, __assign({}, componentProps));
        case FlowPhase.RESET_PASSWORD:
            return _jsx(VerifyResetView, __assign({}, componentProps));
        case FlowPhase.SET_PASSWORD:
            return _jsx(ResetPasswordView, __assign({}, componentProps));
        case FlowPhase.AGREEMENTS:
            return _jsx(AgreementView, __assign({}, componentProps));
        case FlowPhase.PROVISIONAL:
            return _jsx(ProvisionedView, __assign({}, componentProps));
        case FlowPhase.FLOW_RETURN:
            return _jsx(FlowReturnView, __assign({}, componentProps));
        case FlowPhase.PASSKEY:
            return _jsx(PasskeyView, __assign({}, componentProps));
        case FlowPhase.CONSENT:
            return _jsx(ConsentView, __assign({}, componentProps));
        case FlowPhase.COMPLETE:
            return _jsx(FlowCompleteView, __assign({}, componentProps));
        case FlowPhase.INVALID_AUTH_METHOD:
            return _jsx(InvalidAuthView, __assign({}, componentProps));
        case FlowPhase.MISMATCH_EMAIL:
            return _jsx(MismatchEmailView, __assign({}, componentProps));
        case FlowPhase.ERROR:
            return _jsx(ErrorView, __assign({}, componentProps));
        default:
            return _jsx(LoadingView, {});
    }
};
export default AuthFlowView;
